import React from "react";
import styled from "styled-components";
import Typography from "../../../../../components/typography";
import { Colors } from "../../../../../utils/colors";
import PrimaryButton from "../../../../../components/buttons/primary-button";
import { useNavigate } from "react-router-dom";

const OverviewUploadButtons = ({ AddDisabled }: { AddDisabled: boolean }) => {
  const navigate = useNavigate();
  return (
    <Container>
      <GlassBackgrounds>
        <GlassSide>
          <GlassIcons>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 56 56"
              fill="none"
            >
              <path
                d="M30.333 35.0002V25.6668V16.3335"
                stroke="white"
                stroke-width="3.5"
                stroke-linecap="round"
              />
              <path
                d="M25.6667 39.6668C28.244 39.6668 30.3333 37.5775 30.3333 35.0002C30.3333 32.4228 28.244 30.3335 25.6667 30.3335C23.0893 30.3335 21 32.4228 21 35.0002C21 37.5775 23.0893 39.6668 25.6667 39.6668Z"
                stroke="white"
                stroke-width="3.5"
              />
              <path
                d="M37.333 23.3335C33.4669 23.3335 30.333 20.1995 30.333 16.3335"
                stroke="white"
                stroke-width="3.5"
                stroke-linecap="round"
              />
              <path
                d="M32.667 50.8665C31.1592 51.1724 29.5984 51.3332 28.0003 51.3332C15.1137 51.3332 4.66699 40.8864 4.66699 27.9998C4.66699 15.1132 15.1137 4.6665 28.0003 4.6665C40.8869 4.6665 51.3337 15.1132 51.3337 27.9998C51.3337 29.5979 51.1729 31.1587 50.867 32.6665"
                stroke="white"
                stroke-width="3.5"
                stroke-linecap="round"
              />
              <path
                d="M42.0003 51.3333V35M42.0003 35L47.8337 40.8333M42.0003 35L36.167 40.8333"
                stroke="white"
                stroke-width="3.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </GlassIcons>
          <div
            style={{
              display: "flex",
              flexDirection: "column"
            }}
          >
            <Typography
              size="xl"
              weight="semibold"
              mb="0.4"
              color={Colors.white100}
            >
              Upload Music
            </Typography>
            <Typography size="s" color={Colors.white100}>
              Create a new audio track{" "}
            </Typography>
          </div>
        </GlassSide>
        <GlassButton>
          <PrimaryButton
            onClick={() => {
              navigate("/overview/upload-music");
            }}
            disabled={AddDisabled}
            inset
            variant="white"
            text="Upload Track"
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M5.23842 15.8333C3.26598 15.8333 1.66699 14.2532 1.66699 12.3039C1.66699 10.3547 3.26598 8.7745 5.23842 8.7745C5.47518 8.7745 5.70658 8.79725 5.93046 8.84075M5.93046 8.84075C5.73954 8.3315 5.63524 7.78073 5.63524 7.20588C5.63524 4.60689 7.76723 2.5 10.3972 2.5C12.8469 2.5 14.8646 4.32809 15.1296 6.67915M5.93046 8.84075C6.40082 8.932 6.83806 9.1145 7.22255 9.36883M11.9845 6.68934C12.4809 6.51593 13.0152 6.42157 13.5717 6.42157C14.1173 6.42157 14.6414 6.51223 15.1296 6.67915M15.1296 6.67915C16.9945 7.31687 18.3337 9.06758 18.3337 11.1274C18.3337 13.3832 16.7275 15.2684 14.5837 15.7268"
                  stroke="#131313"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
                <path
                  d="M9.99967 13.3335V18.3335M9.99967 13.3335L11.6663 15.0002M9.99967 13.3335L8.33301 15.0002"
                  stroke="#131313"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            }
            iconPosition="right"
          />
        </GlassButton>
      </GlassBackgrounds>
      <GlassBackgrounds>
        <GlassSide>
          <GlassIcons>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 56 56"
              fill="none"
            >
              <path
                d="M28.0003 4.6665C38.9997 4.6665 44.4996 4.6665 47.9165 8.0836C51.3337 11.5007 51.3337 17.0004 51.3337 27.9998C51.3337 38.9992 51.3337 44.4991 47.9165 47.916C44.4996 51.3332 38.9997 51.3332 28.0003 51.3332C17.0009 51.3332 11.5012 51.3332 8.08409 47.916C4.66699 44.4991 4.66699 38.9992 4.66699 27.9998C4.66699 17.0004 4.66699 11.5007 8.08409 8.0836C11.5012 4.6665 17.0009 4.6665 28.0003 4.6665Z"
                stroke="white"
                stroke-width="3.5"
              />
              <path
                d="M50.1663 39.6665H5.83301"
                stroke="white"
                stroke-width="3.5"
                stroke-linecap="round"
              />
              <path
                d="M50.1663 16.3335H5.83301"
                stroke="white"
                stroke-width="3.5"
                stroke-linecap="round"
              />
              <path
                d="M28 4.6665V16.3332M28 51.3332V39.6665"
                stroke="white"
                stroke-width="3.5"
                stroke-linecap="round"
              />
              <path
                d="M39.667 5.8335V16.3335M39.667 50.1668V39.6668"
                stroke="white"
                stroke-width="3.5"
                stroke-linecap="round"
              />
              <path
                d="M16.333 5.8335V16.3335M16.333 50.1668V39.6668"
                stroke="white"
                stroke-width="3.5"
                stroke-linecap="round"
              />
              <path
                d="M32.6663 27.9998C32.6663 26.7683 31.4306 25.9376 28.9591 24.2765C26.4538 22.5928 25.2011 21.7509 24.267 22.3691C23.333 22.9872 23.333 24.658 23.333 27.9998C23.333 31.3416 23.333 33.0125 24.267 33.6306C25.2011 34.2487 26.4538 33.4069 28.9591 31.7231C31.4306 30.062 32.6663 29.2314 32.6663 27.9998Z"
                stroke="white"
                stroke-width="3.5"
                stroke-linecap="round"
              />
            </svg>
          </GlassIcons>
          <div
            style={{
              display: "flex",
              flexDirection: "column"
            }}
          >
            <Typography
              size="xl"
              weight="semibold"
              mb="0.4"
              color={Colors.white100}
            >
              Upload Video
            </Typography>
            <Typography size="s" color={Colors.white100}>
              Release your Music Video
            </Typography>
          </div>
        </GlassSide>
        <GlassButton>
          <PrimaryButton
            onClick={() => {
              navigate("/overview/upload-video");
            }}
            disabled={AddDisabled}
            variant="white"
            text="Upload Video"
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M5.23842 15.8333C3.26598 15.8333 1.66699 14.2532 1.66699 12.3039C1.66699 10.3547 3.26598 8.7745 5.23842 8.7745C5.47518 8.7745 5.70658 8.79725 5.93046 8.84075M5.93046 8.84075C5.73954 8.3315 5.63524 7.78073 5.63524 7.20588C5.63524 4.60689 7.76723 2.5 10.3972 2.5C12.8469 2.5 14.8646 4.32809 15.1296 6.67915M5.93046 8.84075C6.40082 8.932 6.83806 9.1145 7.22255 9.36883M11.9845 6.68934C12.4809 6.51593 13.0152 6.42157 13.5717 6.42157C14.1173 6.42157 14.6414 6.51223 15.1296 6.67915M15.1296 6.67915C16.9945 7.31687 18.3337 9.06758 18.3337 11.1274C18.3337 13.3832 16.7275 15.2684 14.5837 15.7268"
                  stroke="#131313"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
                <path
                  d="M9.99967 13.3335V18.3335M9.99967 13.3335L11.6663 15.0002M9.99967 13.3335L8.33301 15.0002"
                  stroke="#131313"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            }
            iconPosition="right"
          />
        </GlassButton>
      </GlassBackgrounds>
    </Container>
  );
};

export default OverviewUploadButtons;

const Container = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 49% 49%;
  justify-content: space-between;
  margin-bottom: 4rem;
  @media only screen and (max-width: 769px) {
    grid-template-columns: 100%;
    grid-row-gap: 1.6rem;
  }
`;
const GlassBackgrounds = styled.div`
  width: 100%;
  border-radius: 1.1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2.4rem;
  border: 1px solid #4e4e4e;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: 50px;
`;

const GlassIcons = styled.div`
  width: 5.6rem;
  margin-right: 1.7rem;
`;

const GlassSide = styled.div`
  display: flex;
  align-items: center;
`;

const GlassButton = styled.div`
  width: fit-content;
`;
